var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.977539 4.14929C0.977539 2.39758 2.39758 0.977539 4.14928 0.977539H33.9637C35.7154 0.977539 37.1354 2.39758 37.1354 4.14928V33.9637C37.1354 35.7154 35.7154 37.1354 33.9637 37.1354H4.14929C2.39758 37.1354 0.977539 35.7154 0.977539 33.9637V4.14929Z",
    fill: "url(#paint0_linear_427_8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5232 19.0565C29.5232 25.1875 24.5531 30.1576 18.4221 30.1576C12.2912 30.1576 7.32103 25.1875 7.32103 19.0565C7.32103 12.9255 12.2912 7.95538 18.4221 7.95538C24.5531 7.95538 29.5232 12.9255 29.5232 19.0565Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.676 13.8007C22.9778 13.1044 22.032 12.7134 21.0459 12.7134C20.0599 12.7134 19.1141 13.1044 18.4159 13.8007L18.0652 14.1513C17.9722 14.2443 17.92 14.3704 17.92 14.502C17.92 14.6335 17.9722 14.7596 18.0652 14.8526L18.7665 15.5539C18.8595 15.6469 18.9856 15.6991 19.1171 15.6991C19.2486 15.6991 19.3748 15.6469 19.4678 15.5539L19.8184 15.2032C20.144 14.8777 20.5855 14.6948 21.0459 14.6948C21.5063 14.6948 21.9479 14.8777 22.2734 15.2032C22.599 15.5288 22.7819 15.9703 22.7819 16.4307C22.7819 16.8911 22.599 17.3327 22.2734 17.6582L20.5197 19.4114C20.2125 19.7152 19.8035 19.8944 19.3719 19.9142C18.9403 19.9341 18.5166 19.7933 18.1828 19.5191L17.8019 19.2011C17.7009 19.1169 17.5706 19.0763 17.4397 19.0881C17.3087 19.0999 17.1878 19.1632 17.1035 19.2641L16.4677 20.0254C16.426 20.0754 16.3945 20.1332 16.375 20.1954C16.3556 20.2576 16.3486 20.323 16.3544 20.3879C16.3603 20.4528 16.3789 20.5159 16.4091 20.5736C16.4394 20.6313 16.4807 20.6825 16.5307 20.7242L16.9111 21.0416C17.6222 21.6404 18.5327 21.9495 19.4614 21.9073C20.3901 21.8651 21.2689 21.4748 21.9228 20.814L23.6765 19.0608C24.374 18.3632 24.7658 17.4172 24.7658 16.4307C24.7658 15.4443 24.3735 14.4982 23.676 13.8007Z",
    fill: "url(#paint1_linear_427_8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0666 22.5679C17.9736 22.4749 17.8475 22.4227 17.716 22.4227C17.5845 22.4227 17.4584 22.4749 17.3654 22.5679L17.0147 22.9185C16.6892 23.2441 16.2476 23.427 15.7872 23.427C15.3268 23.427 14.8853 23.2441 14.5597 22.9185C14.2342 22.593 14.0513 22.1514 14.0513 21.691C14.0513 21.2306 14.2342 20.7891 14.5597 20.4636L16.3134 18.7103C16.6206 18.4063 17.0295 18.2271 17.4612 18.2072C17.8929 18.1873 18.3166 18.3282 18.6504 18.6027L19.0313 18.9206C19.1322 19.0048 19.2625 19.0455 19.3935 19.0337C19.5244 19.0219 19.6453 18.9586 19.7296 18.8576L20.3654 18.0963C20.4072 18.0463 20.4387 17.9886 20.4581 17.9264C20.4776 17.8642 20.4846 17.7988 20.4787 17.7339C20.4729 17.669 20.4543 17.6059 20.424 17.5482C20.3938 17.4905 20.3524 17.4393 20.3024 17.3975L19.922 17.0801C19.2109 16.4813 18.3004 16.1723 17.3717 16.2145C16.443 16.2566 15.5643 16.647 14.9104 17.3078L13.1567 19.061C12.4642 19.7596 12.0766 20.7042 12.0788 21.6878C12.081 22.6715 12.4728 23.6143 13.1684 24.3099C13.864 25.0054 14.8068 25.3971 15.7905 25.3992C16.7742 25.4013 17.7187 25.0137 18.4173 24.3211L18.7679 23.9705C18.8609 23.8775 18.9131 23.7513 18.9131 23.6198C18.9131 23.4883 18.8609 23.3622 18.7679 23.2692L18.0666 22.5679Z",
    fill: "url(#paint2_linear_427_8)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_427_8",
    x1: 12.0791,
    y1: 19.0568,
    x2: 24.7661,
    y2: 19.0568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1742FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E2796"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_427_8",
    x1: 12.0791,
    y1: 19.0568,
    x2: 24.7661,
    y2: 19.0568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1742FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E2796"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_427_8",
    x1: 12.0791,
    y1: 19.0568,
    x2: 24.7661,
    y2: 19.0568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1742FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E2796"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy_icon.072a7e65119770866f9b7eeeafaf62cd.svg";
export { ForwardRef as ReactComponent };